import React from 'react'
import FlyoutMenu from '../components/flyout-menu/FlyoutMenu.jsx'
import NotebookViewer from '../components/notebook-viewer/NotebookViewer.jsx'
import { graphql } from 'gatsby'
import Layout from '../components/layout.js'
import Masthead from '../components/masthead/Masthead.jsx'
import LauderHeader from '../components/lauderHeader/lauderHeader.jsx'
import { ViewerContext } from '../components/context/ViewerContext.jsx'
import * as R from 'ramda'
//we need to import fonts to use the relative links. Need relative links for local to preview
import BoldItalic from '../fonts/TheMetSerif-BoldItalic.woff'
import Medium from '../fonts/TheMetSans-Medium.woff'
import Medium2 from '../fonts/TheMetSans-Medium.woff2'
import Bold from '../fonts/TheMetSans-Bold.woff'
import SemiBold from '../fonts/TheMetSans-Semibold.woff'
import SemiBold2 from '../fonts/TheMetSans-Semibold.woff2'
import SemiBoldItalic from '../fonts/TheMetSans-SemiboldItalic.woff'
import SemiBoldItalic2 from '../fonts/TheMetSans-SemiboldItalic.woff2'
import RegularItalic from '../fonts/TheMetSans-RegularItalic.woff'
import RegularItalic2 from '../fonts/TheMetSans-RegularItalic.woff2'
import Regular from '../fonts/TheMetSans-Regular.woff'
import LightItalic from '../fonts/TheMetSans-LightItalic.woff'
import LightItalic2 from '../fonts/TheMetSans-LightItalic.woff2'
import Light from '../fonts/TheMetSans-Light.woff'
import Light2 from '../fonts/TheMetSans-Light.woff2'
import SansBoldItalic from '../fonts/TheMetSans-BoldItalic.woff'
import SansBoldItalic2 from '../fonts/TheMetSans-BoldItalic.woff2'

class viewerTemplate extends React.Component {
  render() {
    const allData = this.props.data.importJson.spreads
    const pageId = this.props.pageContext.uid
    const pageData = R.filter(x => x.uid === pageId, allData)[0]
    return (
      <Layout>
        <LauderHeader />
        <ViewerContext.Consumer>
          {value => (
            <Masthead
              showCatalog={true}
              showTitle={true}
              showModeViewer={true}
              toggledSetting={value.state.toggledSetting}
              updateToggledSetting={value.updateToggle}
            />
          )}
        </ViewerContext.Consumer>
        <NotebookViewer
          viewerType="viewer"
          currentView={this.props.location.pathname}
          left={pageData.left}
          right={pageData.right}
          folioNum={pageData.uid}
          tilePrefix="Folio"
        />
        <FlyoutMenu content={pageData} />
      </Layout>
    )
  }
}
FlyoutMenu.contextType = ViewerContext

export default viewerTemplate
export const query = graphql`
  query ViewerPageQuery($uid: Int!) {
    importJson(spreads: { elemMatch: { uid: { eq: $uid } } }) {
      spreads {
        uid
        left {
          side
          title
          sections {
            sectionId
            sectionNum
            translation
            transcription
            coordinates {
              x
              y
              width
              height
            }
            relatedArt {
              footNum
              copy
              image
              link
            }
            translatorNotes {
              footNum
              note
            }

            colorNotes {
              id
              coordinates {
                x
                y
                width
                height
              }
              transcriptionNotes {
                image
                alt
              }

              translationNotes {
                image
                alt
              }
            }
          }
        }

        right {
          side
          title
          sections {
            sectionId
            sectionNum
            translation
            transcription
            coordinates {
              x
              y
              width
              height
            }
            relatedArt {
              footNum
              copy
              image
              link
            }
            translatorNotes {
              footNum
              note
            }

            colorNotes {
              id
              coordinates {
                x
                y
                width
                height
              }
              transcriptionNotes {
                image
                alt
              }

              translationNotes {
                image
                alt
              }
            }
          }
        }
      }
    }
  }
`
